// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__3syl-","title":"styles_title__37cGq","banner":"styles_banner__3-e1-"};